document.addEventListener('DOMContentLoaded', () => {
  const footer = document.querySelector('[data-footer-section]')
  if (!footer) return

  const categoryBand = footer.querySelector('[data-footer-category-band]')
  const desktopQuery = window.matchMedia('(min-width: 1200px)')

  // Category image swap
  if (categoryBand) {
    const imageBase = categoryBand.querySelector('[data-footer-category-image]')
    const overlayWrap = categoryBand.querySelector('[data-footer-category-image-overlay-wrap]')
    const imageOverlay = categoryBand.querySelector('[data-footer-category-image-overlay]')
    const nav = categoryBand.querySelector('[data-footer-category-nav]')
    const categories = nav ? Array.from(nav.querySelectorAll('[data-footer-category]')) : []

    if (imageBase && categories.length) {
      const defaultLink = categories[0]
      const animate = !!(window.gsap && overlayWrap && imageOverlay)
      const srcOf = (link) => link?.getAttribute('data-footer-category-image')

      const setActiveCategory = (activeLink) => {
        categories.forEach((link) => {
          link.classList.toggle('opacity-100', link === activeLink)
          link.classList.toggle('opacity-40', link !== activeLink)
        })
      }

      if (desktopQuery.matches) {
        categories.forEach((link) => {
          const src = srcOf(link)
          if (src) new Image().src = src
        })
      }

      const swapImage = animate
        ? (() => {
            const { gsap } = window
            const SWAP = { duration: 1.05, ease: 'power3.out' }
            let currentSrc = imageBase.dataset.defaultSrc || imageBase.getAttribute('src')
            let pendingSrc = null
            let swapTl = null
            let swapId = 0

            const hideOverlay = () => {
              gsap.set(overlayWrap, { clipPath: 'inset(100% 0 0 0)' })
              gsap.set(imageOverlay, { clearProps: 'transform' })
              imageOverlay.removeAttribute('src')
            }

            const commitSrc = (src) => {
              if (!src) return
              imageBase.src = src
              currentSrc = src
              pendingSrc = null
            }

            hideOverlay()

            return (src) => {
              if (!src) return
              if (src === currentSrc && !swapTl && !pendingSrc) return
              if (src === pendingSrc) return

              const id = ++swapId
              pendingSrc = src

              if (swapTl) {
                swapTl.kill()
                swapTl = null
                const revealed = imageOverlay.getAttribute('src')
                if (revealed) commitSrc(revealed)
                hideOverlay()
              }

              if (src === currentSrc) {
                pendingSrc = null
                return
              }

              imageOverlay.src = src
              gsap.set(overlayWrap, { clipPath: 'inset(100% 0 0 0)' })
              gsap.set(imageOverlay, { scale: 1.1, transformOrigin: 'center center' })

              swapTl = gsap.timeline({
                onComplete: () => {
                  commitSrc(src)

                  const finish = () => {
                    if (id !== swapId) return
                    hideOverlay()
                    swapTl = null
                  }

                  if (imageBase.decode) imageBase.decode().then(finish, finish)
                  else finish()
                },
              })
              swapTl.to(overlayWrap, { clipPath: 'inset(0% 0 0 0)', ...SWAP }, 0)
              swapTl.to(imageOverlay, { scale: 1, ...SWAP }, 0)
            }
          })()
        : (src) => {
            if (src) imageBase.src = src
          }

      const activate = (link) => {
        setActiveCategory(link)
        swapImage(srcOf(link))
      }

      const HOVER_DELAY = 40
      let hoverTimer = null
      let hoveredLink = null

      const cancelHover = () => {
        clearTimeout(hoverTimer)
        hoverTimer = null
      }

      const scheduleActivate = (link) => {
        if (!desktopQuery.matches) return
        if (hoveredLink === link && hoverTimer) return

        cancelHover()
        hoveredLink = link
        hoverTimer = setTimeout(() => {
          hoverTimer = null
          activate(link)
        }, HOVER_DELAY)
      }

      categories.forEach((link) => {
        link.addEventListener('pointerenter', () => scheduleActivate(link))
      })

      nav?.addEventListener('pointerleave', () => {
        cancelHover()
        hoveredLink = null
      })

      setActiveCategory(defaultLink)
      if (!animate) swapImage(srcOf(defaultLink))
    }
  }

  // Mobile accordions
  footer.querySelectorAll('[data-footer-accordion-wrapper]').forEach((wrapper) => {
    const accordion = wrapper.closest('[data-footer-accordion]')
    if (!accordion || accordion.dataset.accordionAnimated) return

    accordion.dataset.accordionAnimated = 'true'

    const summary = accordion.querySelector('summary')
    const content = accordion.querySelector('[data-footer-accordion-content]')
    const linksWrap = accordion.querySelector('[data-footer-accordion-links]')
    if (!summary || !content) return

    const links = linksWrap ? Array.from(linksWrap.children) : []

    const staggerLinks = () => {
      if (!links.length || !window.gsap) return

      window.gsap.fromTo(
        links,
        { autoAlpha: 0, y: 10 },
        { autoAlpha: 1, y: 0, duration: 0.45, stagger: 0.05, ease: 'power2.out', clearProps: 'opacity,visibility,transform' },
      )
    }

    const openAccordion = () => {
      accordion.open = true
      wrapper.style.height = '0px'
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          wrapper.style.height = `${content.scrollHeight}px`
          staggerLinks()
        })
      })
    }

    const closeAccordion = () => {
      accordion.classList.add('is-closing')
      wrapper.style.height = '0px'
      setTimeout(() => {
        accordion.open = false
        accordion.classList.remove('is-closing')
        wrapper.style.height = ''
      }, 400)
    }

    wrapper.style.height = accordion.open ? `${content.scrollHeight}px` : '0px'

    summary.addEventListener('click', (event) => {
      event.preventDefault()
      if (accordion.classList.contains('is-closing')) return
      accordion.open ? closeAccordion() : openAccordion()
    })
  })

  // On load animation
  if (window.gsap) {
    const { gsap } = window
    const revealItems = [...footer.querySelectorAll('[data-footer-reveal]')].filter(
      (item) => item.getClientRects().length && !item.querySelector('[data-newsletter-feedback]'),
    )

    if (revealItems.length) {
      gsap.set(revealItems, { y: 28, autoAlpha: 0 })

      const reveal = () => {
        gsap.to(revealItems, {
          y: 0,
          autoAlpha: 1,
          duration: 1.2,
          ease: 'power3.out',
          stagger: 0.08,
          clearProps: 'transform',
        })
      }

      const reset = () => {
        gsap.set(revealItems, { y: 28, autoAlpha: 0 })
      }

      if (window.ScrollTrigger) {
        window.ScrollTrigger.create({
          trigger: footer,
          start: 'top 80%',
          onEnter: reveal,
        })
        window.ScrollTrigger.create({
          trigger: footer,
          start: 'top bottom',
          onLeaveBack: reset,
        })

        footer
          .querySelectorAll('[data-footer-category-parallax]')
          .forEach((el) => {
            if (!el.getClientRects().length) return

            const wrap = el.closest('.overflow-hidden') || el.parentElement
            gsap.set(el, { scale: 1.25 })
            gsap.fromTo(
              el,
              { yPercent: 8 },
              {
                yPercent: -8,
                ease: 'none',
                scrollTrigger: {
                  trigger: wrap,
                  start: 'top bottom',
                  end: 'bottom top',
                  scrub: true,
                },
              },
            )
          })
      } else {
        reveal()
      }
    }
  }

  const newsletterFeedback = footer.querySelector('[data-newsletter-feedback]')
  const newsletter = newsletterFeedback?.closest('[data-footer-newsletter]')

  if (newsletter) {
    const scrollToNewsletter = () => {
      if (window.lenis) {
        window.lenis.resize()
        window.lenis.scrollTo(newsletter, { immediate: true, force: true })
        return
      }

      newsletter.scrollIntoView({ block: 'start' })
    }

    if (document.readyState === 'complete') requestAnimationFrame(scrollToNewsletter)
    else window.addEventListener('load', () => requestAnimationFrame(scrollToNewsletter), { once: true })
  }
})
